import * as React from 'react';
import { observer } from 'mobx-react-lite';
import StravaConnect from '../comparison/StravaConnect';

interface TrainingRunStepStravaConnectProps {
  isLoading: boolean;
  error: string | null;
  onConnect: () => void;
}

const TrainingRunStepStravaConnect: React.FC<TrainingRunStepStravaConnectProps> = observer(({
  isLoading,
  error,
  onConnect
}) => {
  return (
    <StravaConnect
      isLoading={isLoading}
      error={error}
      onConnect={onConnect}
    />
  );
});

export default TrainingRunStepStravaConnect;
